var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-option cursor-pointer p-2 text-vanilla-300 hover:bg-ink-200",class:[_vm.selected && 'is-selected bg-ink-200', _vm.textSizeClass],on:{"click":function($event){$event.stopPropagation();return _vm.selectOption()}}},[(_vm.$slots.default)?_vm._t("default"):[_vm._v(_vm._s(_vm.label || _vm.value))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }